import type { SimpleChanges } from '@angular/core';
import { Component, Input, output, inject, input } from '@angular/core';
import { RouterModule } from '@angular/router';

import { TranslatePipe } from '@core/i18n-legacy';
import { OfferStatusIndicatorComponent } from '@core/offers-ui';
import type { RequisitionOpening } from '@core/requisitions-types';
import {
  AvatarComponent,
  ButtonComponent,
  DividerComponent,
  HeadingComponent,
  IconComponent,
  RtTooltip,
  TruncateComponent,
} from '@core/user-interface-legacy';

import { RequisitionsCommonTextsService } from '../../services/requisitions-common-texts.service';

@Component({
  selector: 'rt-requisitions-hired-candidate-card',
  templateUrl: './requisitions-hired-candidate-card.component.html',
  styleUrls: ['./requisitions-hired-candidate-card.component.less'],
  imports: [
    AvatarComponent,
    ButtonComponent,
    DividerComponent,
    HeadingComponent,
    IconComponent,
    OfferStatusIndicatorComponent,
    RouterModule,
    RtTooltip,
    TruncateComponent,
    TranslatePipe,
  ],
})
export class RequisitionsHiredCandidateCardComponent {
  private readonly requisitionsCommonTextsService = inject(RequisitionsCommonTextsService);

  public readonly canViewCandidateProfile = input<boolean>(undefined!);
  public readonly canUnassignCandidates = input<boolean>(undefined!);

  public unassignCandidate = output<number>();

  @Input() public filledOpening: RequisitionOpening;

  public candidateDeleted: boolean;

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.filledOpening) this.candidateDeleted = this.isCandidateDeleted();
  }

  public displayAnticipatedStartDate(value: string): string {
    return this.requisitionsCommonTextsService.getFormattedAnticipatedStartDate(value);
  }

  public displayOpeningReason(value: string): string {
    return this.requisitionsCommonTextsService.getOpeningReason(value);
  }

  private isCandidateDeleted(): boolean {
    if (!this.filledOpening.placement) return true;
    return !!this.filledOpening.placement.candidate.deletedAt;
  }
}
